//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vipEquity from './vipEquity.vue';
import payMethod from './payMethod.vue';
export default {
    components: { vipEquity, payMethod },
    mixins: [],
    data() {
        return {
            currentIndex: -1, // 当前选中套餐下标
            currentSelectedPackage: {}, // 当前选中套餐
            packageData: [], // 套餐列表
            currentUserInfo: {
                // 用户信息
                accountId: '', //用户id
                displayName: '', // 用户名
                expireTime: '', // 到期时间
                queryTime: '', // 查询时间
                username: '' // 手机号
            },
            careObjectList: [] // 已守护长者
            // popPayMethod: false // 支付方式选择框 开关
        };
    },
    watch: {
        $route() {
            // 此处写router变化时，想要初始化或者是执行的方法......
            this.getMemberPackage();
        }
    },
    methods: {
        // 查询微信公众号会员价格
        getMemberPackage() {
            let that = this;
            that.$axios.get('/api/v1.0/familyApp/vip/wechat/price', {}).then(function(response) {
                console.log('获取会员套餐类别：' + response);
                that.packageData = response.body.data;
                that.currentIndex = 0;
                that.currentSelectedPackage = Object.assign(that.packageData[0]);
            });
        },
        // 立即支付
        selecetPayMethod() {
            if (this.currentSelectedPackage.type && this.currentUserInfo.accountId) {
                // this.popPayMethod = true; // 弹起支付方式选择框
                var payData = {
                    orderType: this.currentSelectedPackage.type,
                    amount: this.currentSelectedPackage.price,
                    accountId: this.currentUserInfo.accountId
                };
                this.$refs.payMethodRef.showPayAction(payData);
            } else {
                this.$vux.toast.text('请选择需要充值的套餐');
            }
        },
        // 选择套餐
        choosePackage(index_) {
            this.currentIndex = index_;
            this.currentSelectedPackage = Object.assign(this.packageData[index_]);
        },
        // 返回按钮
        preventGoBackHandle() {
            if (this.backPath) {
                this.$router.push(this.backPath);
            } else {
                this.$router.go(-1);
            }
        }
    },
    mounted() {
        document.title = '会员充值';
        this.currentUserInfo = this.$store.state.memberInfo.currentUserInfo;
        this.careObjectList = this.$store.state.memberInfo.careObjectList;
        this.getMemberPackage();
    }
};



// WEBPACK FOOTER //
// ./src/components/member/memberRecharge.vue